export default {"src":"/_next/static/media/TaminLogo.2c4c50dd.svg","height":56,"width":56};